<template>
    <div class="help-wrapper">
        <go-back />

        <div class="adcetris-logo">
            <img src="../../assets/images/moderator/takeda-logo.png" alt="logo">
        </div>        

        <div class="page-wrapper">

            <div class="navigation">

                <div @click="isInstruction = true" :class="isInstruction ? 'active' : ''" class="menu-item">
                    <div class="name">Інструкція</div>
                </div>

                <div @click="isInstruction = false" :class="!isInstruction ? 'active' : ''" class="menu-item">
                    <div class="name">Джерела</div>
                </div>
                
            </div>

            <instruction v-if="isInstruction"/>

            <sources v-else/>
        </div>
    </div>
</template>

<script>
import GoBack from './../../components/Doctor/GoBackButton';
import Instruction from './Help/Instruction';
import Sources from './Help/Sources';

export default {
    components : {
        'go-back' : GoBack,
        'instruction' : Instruction,
        'sources' : Sources
    },
    data : () => ({
        isInstruction : true
    })
}
</script>

<style lang="scss" scoped>
.help-wrapper{
    width: 100%;
    height: 100%;

    background: url("../../assets/images/moderator/patients-bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    position: relative;
    
    .adcetris-logo{
        position: absolute;
        top: 15px;
        right: 40px;

        img{
            width: 120px;
            height: auto;
        }
    }

    .page-wrapper{
        padding: 98px 0 44px;
        display: flex;


        .navigation{
            height: 100%;
            padding-top: 19px;
            padding-right: 50px;

            .menu-item{
                padding: 15px 103px 13px 40px;
                color: #ffffff;
                font-weight: 300;
                font-size: 16px;
                line-height: 20px;

                margin-bottom: 8px;
                text-align: left;
            }

            .active{
                background: rgba(0, 96, 126, 0.3);
                border-left: 7px solid #00607E;

                padding-left: 33px;

                border-top-right-radius: 50px;
                border-bottom-right-radius: 50px;
                font-weight: bold;
            }
        }
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .help-wrapper{
        .page-wrapper{
            padding: 98px 0 44px;
            display: flex;


            .navigation{
                padding-top: 19px;
                padding-right: 3vw;

                .menu-item{
                    padding: 0.9vw 5vw 0.8vw 2vw;
                    color: #ffffff;
                    font-weight: 300;
                    font-size: 1.3vw;
                    line-height: 1.5vw;

                    margin-bottom: 8px;
                    text-align: left;
                }

                .active{
                    background: rgba(0, 96, 126, 0.3);
                    border-left: 7px solid #00607E;

                    padding-left: 33px;

                    border-top-right-radius: 50px;
                    border-bottom-right-radius: 50px;
                    font-weight: bold;
                }
            }
        }
    }
}

@media (max-width: 599px){
    .help-wrapper{
        width: 100%;
        height: 100%;
        min-height: 100%;
        overflow-y: auto;

        background: url("../../assets/images/doctor/help-bg-mobile.png");
        background-size: cover;
        
        .adcetris-logo{
            top: 1.944vw;
            right: 2.778vw;

            img{
                width: 22vw;
            }
        }

        .page-wrapper{
            padding: 21.389vw 2.778vw 16.111vw;

            flex-direction: column;

            .navigation{
                height: auto;
                padding: 0;

                display: flex;
                flex-direction: row;

                .menu-item{
                    padding: 3.056vw 0;
                    width: 50%;

                    font-size: 4.444vw;
                    line-height: 5.556vw;

                    margin-bottom: 0;

                    border: 1px solid #F1F4F5;
                    box-sizing: border-box;

                    .name{
                        text-align: center;
                    }                    
                }

                .menu-item:first-child{
                    border-top-left-radius: 50px;
                    border-bottom-left-radius: 50px;

                    border-right: none;

                    &.active{
                        border: none;

                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;

                        border-right: 7px solid #00607E;
                        border-top-left-radius: 50px;
                        border-bottom-left-radius: 50px;
                    }
                }

                .menu-item:last-child{
                    border-top-right-radius: 50px;
                    border-bottom-right-radius: 50px;

                    border-left: none;

                    &.active{
                        border: none;
                        border-left: 7px solid #00607E;
                        border-top-right-radius: 50px;
                        border-bottom-right-radius: 50px;
                    }
                }
            }
        }
    }
}
</style>